import { AutogenLayoutSalespersonReassignmentProfileList } from "./autogen/AutogenLayoutSalespersonReassignmentProfileList";

export class SalespersonReassignmentProfileList extends AutogenLayoutSalespersonReassignmentProfileList {
    onLoad(): void | Promise<void> {
        this.tableProfiles.addButtonCaption = "Add Salesperson Reassignment Profile";
    }
}